import { render, staticRenderFns } from "./HeavyPackageShipmentForm.vue?vue&type=template&id=52053c81&scoped=true"
import script from "./HeavyPackageShipmentForm.vue?vue&type=script&lang=js"
export * from "./HeavyPackageShipmentForm.vue?vue&type=script&lang=js"
import style0 from "./HeavyPackageShipmentForm.vue?vue&type=style&index=0&id=52053c81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52053c81",
  null
  
)

export default component.exports